import React from 'react';
import { connect } from 'react-redux';
import { isEmpty, truncate } from 'lodash';
import {
  getOnboardingState,
  getEcapState,
  getAuthState,
} from '../../../../store/selectors';
import {
  getTenantHSClassesForAcadplans,
  getEcap,
  getUserDashboardInfo,
} from '../../../../store/actions';
import CoreSubjectsColumn from '../../../ecap/classes/drag-drop/CoreSubjectsColumn';
import { middle } from '../../../../copy/ecap/classesSetupCopy.json';
import {
  getCoreSubjectStrings,
  coreSubjectsEn,
} from '../../../../copy/ecap/classesSetupStrings';
import {
  getRequiredClassesBySubject,
  getRequiredClassesByAcadPlan,
  getSubjectId,
  acadPlanClassMap,
  getCoreSubjectRequirements,
} from '../../../ecap/classes/drag-drop/dragDropUtil';
import Loading from '../../../utility/Loading';
import CareerCardBubble from '../../../utility/CareerCardBubble';

class CareerClassProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: [],
      loading: true,
    };
  }

  componentDidMount = async () => {
    await this.props.getEcap(this.props.auth.jwtToken);
    const acadPlanClasses = await this.acadPlanClasses();
    const progress = await this.progressByDegree(acadPlanClasses);
    this.setState({
      progress,
      loading: false,
    });
  };

  get coreSubjAreaIds() {
    const tempCoreSubjAreaIds = acadPlanClassMap(
      this.acadPlansArray,
      Object.values(coreSubjectsEn)
    );

    if (!isEmpty(this.classLists)) {
      this.acadPlansArray.forEach((acadPlan) => {
        const coreSubjectRequirements = getCoreSubjectRequirements(
          tempCoreSubjAreaIds,
          this.classLists,
          acadPlan
        );

        tempCoreSubjAreaIds[acadPlan] = coreSubjectRequirements[acadPlan];
      });
    }

    if (tempCoreSubjAreaIds && !isEmpty(tempCoreSubjAreaIds))
      return tempCoreSubjAreaIds;

    return [];
  }

  get careerImage() {
    return this.props.career.image;
  }

  careerImageStyle = {
    background: `url(${this.careerImage}) no-repeat center`,
    backgroundSize: 'cover',
  };

  get acadPlansArray() {
    if (this.props.location.pathname.includes('user-profile')) {
      return Object.values(this.props.userProfile.degreeChoices).map(
        (degree) => degree.acadPlan
      );
    }
    return Object.values(this.props.onboarding.degreeChoices).map(
      (degree) => degree.acadPlan
    );
  }

  get tenantId() {
    if (this.props.location.pathname.includes('user-profile')) {
      return this.props.userProfile?.tenantId;
    }
    return this.props.tenant.id;
  }

  getRequiredClassesBySubjectParent = async (subject, acadPlanClasses) => {
    const requiredClassesByAcadPlan = getRequiredClassesByAcadPlan(
      this.getCurrentDegree().acadPlan,
      acadPlanClasses
    );
    const requiredClassesBySubject = getRequiredClassesBySubject(
      getSubjectId(subject),
      requiredClassesByAcadPlan
    );

    return { [subject]: requiredClassesBySubject, requiredClassesByAcadPlan };
  };

  getCurrentDegree = () => {
    if (this.props.location.pathname.includes('user-profile')) {
      return Object.values(this.props.userProfile.degreeChoices).find(
        (degree) => {
          return this.props.career.degreeId === degree.id;
        }
      );
    }
    return Object.values(this.props.onboarding.degreeChoices).find((degree) => {
      return this.props.career.degreeId === degree.id;
    });
  };

  progressByDegree = (acadPlanClasses) => {
    const obj = {};
    const degree = this.getCurrentDegree();
    Object.values(coreSubjectsEn).map(async (subject) => {
      const requiredClasses = await this.getRequiredClassesBySubjectParent(
        subject,
        acadPlanClasses
      );
      if (!obj[subject]) {
        obj[subject] = requiredClasses[subject];
      }
    });
    obj.totalRequiredClasses = acadPlanClasses.filter(
      (x) => x.acad_plan === degree.acadPlan
    );
    return obj;
  };

  acadPlanClasses = () => {
    return this.props.getTenantHSClassesForAcadplans(
      this.tenantId,
      this.acadPlansArray
    );
  };

  render() {
    const { loading } = this.state;
    const coreSubjectAreaIds = this.coreSubjAreaIds;
    const degree = this.getCurrentDegree();
    const degreeTitle = truncate(degree.titleEn, {
      length: 90,
    });
    return loading ? (
      <Loading height="100%" />
    ) : (
      <div id="info-container" className="info-container">
        <div className="info-container__img-title-container">
          <div className="info-container__bubble-progress-bar">
            <CareerCardBubble
              totalRequiredClasses={
                this.state.progress.totalRequiredClasses.length
              }
              color={this.props.tenant.primary}
              progressByDegree={this.state.progress}
              placedClasses={
                this.props.location.pathname.includes('user-profile')
                  ? this.props.userProfile.ecapPlan.classes_matched
                  : this.props.ecap.plan.classes_matched
              }
            />
          </div>
          <div className="info-container__degree-title-boundary">
            <div className="info-container__degree-title-box">
              <div className="info-container__degree-title">{degreeTitle}</div>
            </div>
          </div>
          <div
            style={this.careerImageStyle}
            className="info-container__career-image"
          />
        </div>
        {this.props.displayProgress ? (
          <div className="info-container__class-progress">
            <CoreSubjectsColumn
              tenant={this.props.tenant}
              coreSubjectsList={Object.values(getCoreSubjectStrings())}
              coreSubjectsListEn={Object.values(coreSubjectsEn)}
              modalImage={this.careerImage}
              acadPlanClasses={coreSubjectAreaIds[degree.acadPlan]}
              placedClasses={
                this.props.location.pathname.includes('user-profile')
                  ? this.props.userProfile.ecapPlan.classes_matched
                  : this.props.ecap.plan.classes_matched
              }
              progressByDegree={this.state.progress}
              rightBubbleOffset="25px"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const ecap = getEcapState(state);
  const auth = getAuthState(state);
  const userProfile = state.admin.userProfileInfo;

  return { onboarding, ecap, auth, userProfile };
}

export default connect(mapStateToProps, {
  getTenantHSClassesForAcadplans,
  getEcap,
  getUserDashboardInfo,
})(CareerClassProgress);
